// usePricingConfig — frontend hook that fetches /api/config/pricing (single source of truth).
// सभी frontend components इसे use करें ताकि backend में pricing update होते ही UI reflect हो।
import { useEffect, useState } from 'react';

const FALLBACK = {
  model_type: 'one_time_plus_maintenance',
  one_time_price: 4999,
  founding_one_time_price: 2499,
  annual_maintenance: 999,
  byok_required: true,
  founding_discount_percent: 50,
  founding_schools_limit: 50,
  discount_applies_to_year: 1,
  discount_applies_to: 'first_year_only',
  min_wallet_recharge: 100,
  currency: 'INR',
  currency_symbol: '₹',
  sales_contact_phone: '9826618603',
  pricing_tiers: [
    { min: 1, max: 300, one_time: 4999, annual_maintenance: 999, custom: false, label_hi: '1–300 users', label_en: '1–300 users' },
    { min: 301, max: 600, one_time: 6999, annual_maintenance: 1199, custom: false, label_hi: '301–600 users', label_en: '301–600 users' },
    { min: 601, max: 1000, one_time: 8999, annual_maintenance: 1399, custom: false, label_hi: '601–1000 users', label_en: '601–1000 users' },
    { min: 1001, max: 1500, one_time: 9999, annual_maintenance: 1499, custom: false, label_hi: '1001–1500 users', label_en: '1001–1500 users' },
    { min: 1501, max: 2500, one_time: 12999, annual_maintenance: 1999, custom: false, label_hi: '1501–2500 users', label_en: '1501–2500 users' },
    { min: 2501, max: 3500, one_time: 15999, annual_maintenance: 2999, custom: false, label_hi: '2501–3500 users', label_en: '2501–3500 users' },
    { min: 3501, max: 5000, one_time: 19999, annual_maintenance: 4999, custom: false, label_hi: '3501–5000 users', label_en: '3501–5000 users' },
    { min: 5001, max: null, one_time: 0, annual_maintenance: 0, custom: true, label_hi: '5000+ users (Custom)', label_en: '5000+ users (Custom)' },
  ],
  // legacy (kept for backward-compat with older components)
  base_price_per_user_year: 100,
  founding_price_per_user_year: 50,
  display: {
    standard_rate: '₹4999 one-time + ₹999/year',
    founding_rate: '₹2499 one-time + ₹999/year',
    one_time_line_en: 'Software LIFETIME FREE. One-time ₹4999 (license + setup) + ₹999/year maintenance. No per-student charge.',
    one_time_line_hi: 'Software LIFETIME FREE। एक-बार ₹4999 (license + setup) + ₹999/साल maintenance। कोई per-student charge नहीं।',
    founding_offer_line_en: 'First 50 schools get 50% OFF the one-time — just ₹2499 (+ ₹999/year). Seat reserved only on payment.',
    founding_offer_line_hi: 'पहले 50 स्कूल जो payment करें, one-time पर 50% OFF — सिर्फ ₹2499 (+ ₹999/साल)। Seat सिर्फ payment पर reserve।',
    byok_line_en: 'AI runs on your OWN Google Gemini key (BYOK mandatory). Your data, your key, your control.',
    byok_line_hi: 'AI आपकी अपनी Google Gemini key पर चलता है (BYOK अनिवार्य)। आपका data, आपकी key, आपका control।',
    note_en: 'Software lifetime FREE. Revenue only from one-time license/setup + optional yearly maintenance. Schools bring their own API keys (BYOK).',
    note_hi: 'Software lifetime FREE। Revenue सिर्फ one-time license/setup + yearly maintenance से। Schools अपने खुद के API keys लाते हैं (BYOK)।',
  },
  founding_schools_stats: { claimed: 0, remaining: 0, total_slots: 0, percent_filled: 0, is_open: false },
  founding_offer_enabled: false,
};

let _cache = null;
let _cachePromise = null;

export function usePricingConfig() {
  const [config, setConfig] = useState(_cache || FALLBACK);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache) {
      setConfig(_cache);
      setLoading(false);
      return;
    }
    if (!_cachePromise) {
      const base = process.env.REACT_APP_BACKEND_URL;
      _cachePromise = fetch(`${base}/api/config/pricing`)
        .then((r) => (r.ok ? r.json() : FALLBACK))
        .then((d) => {
          _cache = d?.success === false ? FALLBACK : { ...FALLBACK, ...d };
          return _cache;
        })
        .catch(() => {
          _cache = FALLBACK;
          return _cache;
        });
    }
    _cachePromise.then((c) => {
      setConfig(c);
      setLoading(false);
    });
  }, []);

  return { config, loading };
}

export function formatPrice(cfg, amount) {
  const sym = cfg?.currency_symbol || '₹';
  return `${sym}${Number(amount).toLocaleString('en-IN')}`;
}
